import type { RegionIssuesBadgeFragment } from "../client/generated";
import { IssuesBadge } from "./IssuesBadge";

type Props = {
  fragment: RegionIssuesBadgeFragment;
};

export function RegionIssuesBadge({ fragment }: Props) {
  return <IssuesBadge count={fragment.issues.length} />;
}
